<app-thi-page-shell [lang]="landingLang">
  <div class="overflow-hidden">
    <section class="relative pt-40 pb-24 thi-section-gradient-soft overflow-hidden">
      <div class="container mx-auto px-4 relative z-10">
        <div class="max-w-4xl mx-auto text-center">
          <h1 class="text-4xl md:text-5xl lg:text-6xl font-bold text-foreground mb-6">{{ t.resources.title }}</h1>
          <p class="text-xl text-muted-foreground">{{ t.resources.subtitle }}</p>
        </div>
      </div>
    </section>

    <section class="py-8 bg-background border-b border-border">
      <div class="container mx-auto px-4">
        <div class="flex flex-wrap justify-center gap-3">
          <button
            type="button"
            *ngFor="let fl of filterIds"
            (click)="setFilter(fl.id)"
            class="flex items-center gap-2 px-5 py-2.5 rounded-full transition-all text-sm font-semibold border"
            [ngClass]="
              activeFilter === fl.id
                ? 'bg-primary text-primary-foreground border-primary shadow-md'
                : 'bg-card border-border text-foreground hover:border-primary/30'
            "
          >
            <i *ngIf="fl.icon" [class]="fl.icon + ' text-xs'"></i>
            {{ fl.label }}
          </button>
        </div>
      </div>
    </section>

    <section class="py-24 bg-background">
      <div class="container mx-auto px-4">
        <div class="grid md:grid-cols-2 lg:grid-cols-3 gap-8 max-w-6xl mx-auto">
          <a
            *ngFor="let article of filteredArticles"
            [routerLink]="['/articles', article.id]"
            class="group bg-card border border-border rounded-2xl overflow-hidden hover:border-primary/30 transition-all hover:shadow-lg block no-underline text-inherit"
          >
            <div class="relative h-48 overflow-hidden">
              <img [src]="article.image" [alt]="article.title[landingLang]" class="w-full h-full object-cover transition-transform duration-300 group-hover:scale-105" />
              <div class="thi-article-card-fade" aria-hidden="true"></div>
              <div class="absolute bottom-4 start-4 flex items-center gap-2">
                <span
                  class="flex items-center gap-1.5 bg-primary text-primary-foreground text-xs font-medium px-3 py-1 rounded-full"
                >
                  <i class="fa fa-tag text-[10px]"></i>
                  {{ categoryLabel(article.category) }}
                </span>
              </div>
            </div>
            <div class="p-6">
              <div class="flex items-center gap-3 text-xs text-muted-foreground mb-3">
                <span>{{ article.date }}</span>
                <span class="flex items-center gap-1">
                  <i class="fa fa-clock-o"></i>
                  {{ article.readTime }} {{ t.resources.minRead }}
                </span>
              </div>
              <h3 class="text-lg font-bold text-foreground mb-3 group-hover:text-primary transition-colors line-clamp-2">
                {{ article.title[landingLang] }}
              </h3>
              <p class="text-muted-foreground text-sm mb-4 line-clamp-2">{{ article.excerpt[landingLang] }}</p>
              <span class="inline-flex items-center gap-2 text-primary text-sm font-medium">
                {{ t.resources.readMore }}
                <i
                  class="transition-transform group-hover:translate-x-1 rtl:group-hover:-translate-x-1"
                  [ngClass]="arrowIcon"
                ></i>
              </span>
            </div>
          </a>
        </div>
      </div>
    </section>
  </div>
</app-thi-page-shell>
